module.exports = __webpack_public_path__ + "img/wing-left.d899b1a3.svg";